export const LINKS = {
  spotify: "https://open.spotify.com/artist/69XsmOvvLdpDC850UFpuJI",
  apple: "https://music.apple.com/us/artist/xo-vasco/1549407946",
  instagram: "https://www.instagram.com/xovasco/",
  youtube: "https://www.youtube.com/@XOVasco",
};

export const TABS = ["TOUR", "MERCH", "MUSIC", "VIDEOS"];

const ART = "https://i.scdn.co/image/ab67616d00001e02";

export const RELEASES = [
  { title: "BLESS US ALL", type: "Album", art: `${ART}b896dd9ef440c5fe70392b24`, kind: "album", id: "0v98hcaaBMklNRnA7Qff70" },
  { title: "SK8 FLO", type: "Single", art: `${ART}0565c2da3e0f21c5935b3897`, kind: "album", id: "3pz7sIvMSKbnsV90XO8o96" },
  { title: "INVISIBLE SET DIAMONDS", type: "Single", art: `${ART}a03665e2b07412193c9a986b`, kind: "album", id: "4zt4pjjBxb45QvgkLCPLhY" },
  { title: "CALLING", type: "Single", art: `${ART}2f13546ea99f3413afcc6eed`, kind: "album", id: "16W63vGije477tvfHIIRhm" },
  { title: "AINTFORME / WORKWORKWORK", type: "EP", art: `${ART}116728e234cc0bde62487440`, kind: "album", id: "0aDI4Dl9KRQ1JOx3ex9VoQ" },
  { title: "GANJA", type: "Single", art: `${ART}c95134d71fe427ed14b5a272`, kind: "track", id: "6FiaPsDdMwd2rwE38WaDdh" },
  { title: "TELL ME I'M WRONG", type: "Single", art: `${ART}c1100e874e2fbafa8d07555b`, kind: "track", id: "371ahdoIyqN7pxdAIXbHNy" },
  { title: "BE ALRIGHT!", type: "Single", art: `${ART}42a63817299540bf72e99f17`, kind: "track", id: "6gxrr8hgNXzEf02XnpTpxV" },
];

export const VIDEOS = [
  { title: "BUA WORLD", id: "AOHO6bCBA3I" },
  { title: "CALLING", id: "H9sp63P8A9U" },
  { title: "RANDOMS", id: "9EX4JDbJECo" },
  { title: "ON ME", id: "UiwvJ2OcOjw" },
];

export const DATES = [
  { day: "22", month: "NOV", location: "Houston, TX", tickets: "https://posh.vip/f/649c0?t=xovasco" },
  { day: "03", month: "DEC", location: "Sunrise, FL", tickets: "https://posh.vip/e/tsgfest-2026" },
  { day: "08", month: "JAN", location: "Orlando, FL", tickets: "https://posh.vip/e/korqo-evb-can-die-fl-tour-orlando?t=xovasco" },
  { day: "28", month: "JAN", location: "Denver, CO", tickets: "https://posh.vip/e/die-moshing-denver-co-2facedlonkorqolifeline?u=inhalemusic&_t=mw07ql73&os=ios&src=event_page" },
];
